import { convertTimeToMilliseconds } from '../time-converter';

type RefreshFunction = () => Promise<{ expiration?: string } | null>;

let tokenRefreshTimeout: NodeJS.Timeout | null = null;

export const clearTokenRefreshTimeout = () => {
  if (tokenRefreshTimeout) {
    clearTimeout(tokenRefreshTimeout);
    tokenRefreshTimeout = null;
  }
};

export const scheduleTokenRefresh = (expiration: string | number, refreshFn: RefreshFunction) => {
  clearTokenRefreshTimeout();

  // number = Unix timestamp in seconds (JWT exp claim) → compute exact remaining time
  // string = duration like "15m" → convert to ms from now
  const refreshTime =
    typeof expiration === 'number'
      ? expiration * 1000 - Date.now() - 10000
      : convertTimeToMilliseconds(expiration || '1h') - 10000; // 10 seconds before expiration

  if (refreshTime > 0) {
    tokenRefreshTimeout = setTimeout(async () => {
      try {
        const newTokens = await refreshFn();

        if (newTokens?.expiration) {
          scheduleTokenRefresh(newTokens.expiration, refreshFn);
        }
      } catch (error) {
        // responseError interceptor transforms the error to response.data shape { statusCode, message }
        // so we need to check all possible status field names
        const status =
          (error as any)?.response?.status ??
          (error as any)?.status ??
          (error as any)?.statusCode;
        if (status === 401) {
          window.location.href = '/login';
        }
      }
    }, refreshTime);
  }
};
